<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="tds-overlay"
      @click.self="onOverlayClick"
    >
      <div class="tds-modal">
        <div class="tds-modal__header">
          <span>3D Secure Authentication</span>
          <button class="tds-modal__close" @click="onClose">✕</button>
        </div>
        <div class="tds-modal__body">
          <iframe
            v-if="url"
            ref="tdsFrame"
            :src="url"
            class="tds-modal__frame"
            allow="payment"
            @load="onFrameLoaded"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  CHECKOUT_PAYMENT_RECEIVED,
  CHECKOUT_PAYMENT_FAILED,
  CHECKOUT_PAYMENT_STATE_UNKNOWN,
  CHECKOUT_EVENT_COMPLETE,
  CHECKOUT_EVENT_FAILED
} from '@vue/common/constants/windowEventDiscriminators'

import {
  TDS_RESULT,
} from '@vue/common/constants/threeDSEventConstants'

export default {
  name: 'ThreeDSModal',

  props: {
    url: {
      type: String,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    visible(val) {
      // Prevent background scrolling while modal is open
      document.body.style.overflow = val ? 'hidden' : '';
    },
  },

  mounted() {
    window.addEventListener('message', this.onPostMessage);
  },

  beforeDestroy() {
    document.body.style.overflow = '';
    window.removeEventListener('message', this.onPostMessage);
  },

  methods: {
    onFrameLoaded() {
      this.$emit('frame-loaded');
    },

    onClose() {
      this.$emit('close');
    },

    // Prevent accidental dismissal by clicking the overlay
    onOverlayClick() {
      // Intentionally a no-op — user must complete or close via the button
    },

    onPostMessage(event) {
      if (event.origin !== window.location.origin) return;

      switch (event.data?.type) {
        // 3DS complete
        case TDS_RESULT:
          event.data.status === 'SUCCESS'
            ? this.$emit(CHECKOUT_EVENT_COMPLETE)
            : this.$emit(CHECKOUT_EVENT_FAILED);
          break;

        // Payment status page results
        case CHECKOUT_PAYMENT_RECEIVED:
          this.$emit(CHECKOUT_EVENT_COMPLETE);
          break;

        case CHECKOUT_PAYMENT_FAILED:
          this.$emit(CHECKOUT_EVENT_FAILED);
          break;

        case CHECKOUT_PAYMENT_STATE_UNKNOWN:
          // Page is retrying — stay open and wait
          break;
      }
    },
  },
};
</script>
